// Push-to-talk clips as WAV (ptt.ts): the 16-bit PCM frames the pcm16 worklet posts, behind a 44-byte header. Every
// speaker path plays WAV: NX takes its PCM paced (video-gateway audio.ts), and the EyeQ AI VMS converts it for its
// speakers (its SOC_INTEGRATION.md §3.1), where a MediaRecorder clip (WebM/Ogg) is refused.

/** A mono 16-bit PCM WAV of `frames` (s16le) at `rate`. */
export function wavOf(frames: ArrayBuffer[], rate: number): Blob {
  const bytes = frames.reduce((n, f) => n + f.byteLength, 0);
  const h = new DataView(new ArrayBuffer(44));
  const ascii = (o: number, s: string) => [...s].forEach((c, i) => h.setUint8(o + i, c.charCodeAt(0)));
  ascii(0, 'RIFF');
  h.setUint32(4, 36 + bytes, true);
  ascii(8, 'WAVE');
  ascii(12, 'fmt ');
  h.setUint32(16, 16, true);
  h.setUint16(20, 1, true); // PCM
  h.setUint16(22, 1, true); // mono
  h.setUint32(24, rate, true);
  h.setUint32(28, rate * 2, true);
  h.setUint16(32, 2, true);
  h.setUint16(34, 16, true);
  ascii(36, 'data');
  h.setUint32(40, bytes, true);
  return new Blob([h.buffer, ...frames], { type: 'audio/wav' });
}

/** How long `bytes` of mono 16-bit PCM at `rate` lasts, in ms. */
export const pcmMs = (bytes: number, rate: number) => Math.round((bytes / 2 / rate) * 1000);
